import * as yup from 'yup'

import { CONTACT_US_FORM_PAGE_CONSTANTS_PATH } from './ContactUsForm.PageConstants'
import { T_CONTACT_US_FORM } from './ContactUsForm.Types'

export const INITIAL_VALUES: T_CONTACT_US_FORM = {
  fullName: '',
  emailId: '',
  subject: '',
  message: ''
}

export const VALIDATION_SCHEMA = yup
  .object<T_CONTACT_US_FORM>({
    fullName: yup
      .string()
      .trim()
      .required(
        CONTACT_US_FORM_PAGE_CONSTANTS_PATH('FULL_NAME_ERRORS_REQUIRED')
      ),
    emailId: yup
      .string()
      .trim()
      .required(CONTACT_US_FORM_PAGE_CONSTANTS_PATH('EMAIL_ID_ERRORS_REQUIRED'))
      .email(CONTACT_US_FORM_PAGE_CONSTANTS_PATH('EMAIL_ID_ERRORS_INVALID')),
    subject: yup
      .string()
      .trim()
      .required(CONTACT_US_FORM_PAGE_CONSTANTS_PATH('SUBJECT_ERRORS_REQUIRED')),
    message: yup
      .string()
      .trim()
      .required(CONTACT_US_FORM_PAGE_CONSTANTS_PATH('MESSAGE_ERRORS_REQUIRED'))
  })
  .json()
  .noUnknown()
  .camelCase()
